module.exports = __webpack_public_path__ + "img/Exams-background-blue.329f4a3e.svg";